export default __webpack_public_path__ + "static/media/kids.b1f45ef9.png";